module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'iphone-x': _vm.isIphoneX
    }
  }, [(!_vm.nocache && (_vm.product && _vm.env === 'm-web')) ? _c('down-banner', {
    attrs: {
      "position": 'top',
      "pageType": 'product',
      "link": 'product/' + _vm.product.id
    },
    on: {
      "close-banner": _vm.closeBanner,
      "banner-close": _vm.closeBanner
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product && !_vm.product.invisible) ? _c('beast-main', {
    class: {
      'down-banner': _vm.env === 'm-web' && _vm.showDownBanner
    },
    attrs: {
      "errorMsg": _vm.errorMsg
    }
  }, [(_vm.pageType === 'LESSON' && _vm.product) ? _c('div', {
    staticClass: "l-detail-wrap"
  }, [_c('lesson-product-banner', {
    attrs: {
      "product": _vm.product,
      "sdk": _vm.sdk,
      "env": _vm.env
    }
  }), _vm._v(" "), _c('lesson-product-info', {
    attrs: {
      "product": _vm.product,
      "sdk": _vm.sdk,
      "env": _vm.env
    }
  }), _vm._v(" "), _c('lesson-comment', {
    attrs: {
      "comment": _vm.cmtRecommand,
      "sdk": _vm.sdk,
      "env": _vm.env,
      "productId": _vm.productId
    }
  }), _vm._v(" "), (_vm.detailNew) ? _c('lesson-product-detail', {
    attrs: {
      "data": _vm.detailNew
    }
  }) : _vm._e(), _vm._v(" "), _c('lesson-footer', {
    attrs: {
      "product": _vm.product,
      "sdk": _vm.sdk,
      "env": _vm.env
    }
  })], 1) : _c('div', {
    staticClass: "p-detail-wrap"
  }, [_c('product-images', {
    attrs: {
      "nocache": _vm.nocache,
      "product": _vm.product,
      "djsformat": _vm.djsformat
    },
    on: {
      "favorite": _vm.favorite
    }
  }), _vm._v(" "), (_vm.product) ? _c('down-payment', {
    attrs: {
      "product": _vm.product
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product && _vm.prodCoupons.length) ? _c('coupons', {
    attrs: {
      "product": _vm.product,
      "prodCoupons": _vm.prodCoupons
    },
    on: {
      "show": _vm.showCoupons
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.matchProducts && _vm.product.matchProducts.length) ? _c('div', {
    staticClass: "product-rc"
  }, [_c('div', {
    staticClass: "rc-list"
  }, [_c('div', {
    staticClass: "rc-wrap"
  }, _vm._l((_vm.product.matchProducts), function(rcProd, index) {
    return _c('div', {
      staticClass: "rc-item",
      class: {
        'active': _vm.curRcActive == index
      },
      on: {
        "click": function($event) {
          return _vm.goDetail(rcProd.productCode, 'rc', index, rcProd.productName)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": rcProd.image
      }
    })])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.product) ? _c('product-info', {
    attrs: {
      "product": _vm.product,
      "fundPrice": _vm.fundPrice
    },
    on: {
      "showPriceTag": _vm.showPriceTag
    }
  }) : _vm._e(), _vm._v(" "), _c('select-address', {
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), _c('labels', {
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), (_vm.product && _vm.product.groupon) ? _c('div', {
    staticClass: "purchase-group",
    on: {
      "click": function($event) {
        return _vm.goPurchase(_vm.product.groupon.link)
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("闺蜜团开团中")]), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.product.groupon.number) + "人组团每人只需￥" + _vm._s(_vm.product.groupon.range[0]) + " "), (_vm.product.groupon.range[0] != _vm.product.groupon.range[1]) ? _c('span', [_vm._v(" - ￥" + _vm._s(_vm.product.groupon.range[1]))]) : _vm._e(), _vm._v("，  快来参加吧！")]), _vm._v(" "), _c('i')]) : _vm._e(), _vm._v(" "), (_vm.product && _vm.product.badges && _vm.product.badges.length) ? _c('product-badges', {
    attrs: {
      "product": _vm.product
    }
  }) : _vm._e(), _vm._v(" "), _c('detail-tab'), _vm._v(" "), (_vm.product && _vm.product.legacyDetails) ? _c('product-desc', {
    attrs: {
      "detail": _vm.detail
    }
  }) : _c('product-desc-new', {
    attrs: {
      "data": _vm.detailNew,
      "pageTypeImage": _vm.pageTypeImage
    }
  }), _vm._v(" "), (!_vm.nocache) ? _c('suggest', {
    attrs: {
      "productId": _vm.productId,
      "source": 'PRODUCT'
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.nocache && !_vm.product.invisible) ? _c('product-footer', {
    ref: "pFooter",
    attrs: {
      "env": _vm.env,
      "product": _vm.product,
      "isApp": _vm.isApp,
      "msgCount": _vm.receiveMsgs.length || _vm.offMessageCount,
      "suggestType": _vm.suggestType
    },
    on: {
      "showWechatGift": _vm.doShowWechatGift,
      "showMask": _vm.showDownloadMask,
      "openService": _vm.openService,
      "change": _vm.changeFund
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showTagInfo && _vm.product.spvPriceInfo) ? _c('div', {
    staticClass: "tag-infos"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("折扣明细")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "price-step"
  }, _vm._l((_vm.product.spvPriceInfo.priceSteps), function(priceStep) {
    return _c('div', {
      staticClass: "info-item"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(priceStep.name))]), _vm._v(" "), _c('span', {
      staticClass: "price",
      style: ({
        color: priceStep.fontColor
      })
    }, [_c('price', {
      attrs: {
        "data": priceStep.priceChange
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "after-price"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("折后价")]), _vm._v(" "), _c('div', {
    staticClass: "item price"
  }, [_c('price', {
    attrs: {
      "data": _vm.product.spvPriceInfo.discountPrice
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.product.spvPriceInfo.desc) ? _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.product.spvPriceInfo.desc || ''))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.closeTagInfo
    }
  }, [_vm._v("确定")])])]) : _vm._e(), _vm._v(" "), (_vm.showCouponList) ? _c('div', {
    staticClass: "coupon-wrap"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hideCouponsList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupons-box"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("领取优惠券")]), _vm._v(" "), _c('div', {
    staticClass: "coupon-list"
  }, _vm._l((_vm.prodCouponsList), function(item) {
    return _c('div', {
      staticClass: "coupon-item",
      class: {
        used: item.couponOwnerState !== 'ABLE'
      }
    }, [_c('div', {
      staticClass: "left"
    }, [(item.discount) ? _c('div', {
      staticClass: "price"
    }, [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(item.discount))]) : (item.discountRatio) ? _c('div', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.discountRatio * 10) + " 折")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.thresholdDesc))]), _vm._v(" "), (item.dateWay == 'NUMBER') ? _c('div', {
      staticClass: "date"
    }, [_vm._v("使用期限: 领取后" + _vm._s(item.dateNum) + "天")]) : _c('div', {
      staticClass: "date"
    }, [_vm._v("使用期限: " + _vm._s(_vm._f("formatTime")(item.startTime)) + " 至 " + _vm._s(_vm._f("formatTime")(item.expireTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "right",
      class: {
        used: item.couponOwnerState === 'ALABLE'
      }
    }, [(item.couponOwnerState === 'ABLE') ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.getCouponById(item.id)
        }
      }
    }, [_vm._v("立即领取")]) : _c('div', {}, [_vm._v("立即领取")])]), _vm._v(" "), (item.couponOwnerState == 'ALABLE') ? _c('img', {
      attrs: {
        "src": require("./assets/icon-able.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.couponOwnerState == 'UNABLE') ? _c('img', {
      attrs: {
        "src": require("./assets/icon-finish.png")
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.hideCouponsList
    }
  }, [_vm._v("确定")])])])]) : _vm._e()]) : (_vm.product && _vm.product.invisible) ? _c('beast-main', {
    class: {
      'down-banner': _vm.env === 'm-web' && _vm.showDownBanner
    },
    attrs: {
      "errorMsg": _vm.errorMsg
    }
  }, [_c('img', {
    staticClass: "p-invisible",
    attrs: {
      "src": "//img.thebeastshop.com/app/4.0/bg-invisible.jpeg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDownMask),
      expression: "showDownMask"
    }],
    staticClass: "mask-wrap",
    on: {
      "click": function($event) {
        _vm.showDownMask = !_vm.showDownMask
      }
    }
  }, [_c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showQXLpBox),
      expression: "showQXLpBox"
    }],
    staticClass: "qxlp-box-wrap"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.toggleQXLpBox
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.toggleQXLpBox
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tit"
  }, [_vm._v("刻字服务规则须知")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rule-confirm"
  }, [_c('div', {
    staticClass: "chk-box",
    on: {
      "click": _vm.checkQxlpChecked
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qxlpChecked),
      expression: "qxlpChecked"
    }],
    attrs: {
      "src": "//img.thebeastshop.com/app/activity/qxlp/icon-checked.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.qxlpChecked),
      expression: "!qxlpChecked"
    }],
    attrs: {
      "src": "//img.thebeastshop.com/app/activity/qxlp/icon-check.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chk-txt"
  }, [_vm._v("本人已阅读并同意上述规则")])]), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "btn-item",
    on: {
      "click": function($event) {
        return _vm.confirmCustomCard(true)
      }
    }
  }, [_vm._v("确认刻字")]), _vm._v(" "), _c('div', {
    staticClass: "btn-item grey",
    on: {
      "click": _vm.confirmCustomCard
    }
  }, [_vm._v("无需刻字")])])])]), _vm._v(" "), (_vm.isShowWechatGift) ? _c('gift-wechat-box', {
    on: {
      "buyWechatGift": function($event) {
        return _vm.buyWechatGift('wechatGift')
      },
      "hide": function($event) {
        _vm.isShowWechatGift = false;
        _vm.showWechatGiftAni = false;
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prompt"
  }, [_vm._v("点击右上角菜单"), _c('br'), _vm._v("“在浏览器打开”并安装野兽派")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule-content"
  }, [_c('p', [_vm._v("1. 目前仅支持每个输入框填写1个大写英文字母，共两个输入框可输入字符，不支持符号和表情；例如框内可分别输入：“M ”和“ L”。")]), _vm._v(" "), _c('p', [_vm._v("2. 本商品为专属定制商品，定制时我们会为您调整为合适的字体大小及位置，尽可能呈现良好的效果。实际效果以收到的实物为准；")]), _vm._v(" "), _c('p', [_vm._v("3. 确认刻字内容后一旦提交订单，不支持修改。")]), _vm._v(" "), _c('p', [_vm._v("4. 选择刻字服务的订单一经付款，即进入定制阶段，不支持无理由取消订单（即退货、退款）；")]), _vm._v(" "), _c('p', [_vm._v("5. 由于刻字工艺耗时，刻字订单将预计于付款后48小时内发货，且不为此类订单提供非质量问题的退换货服务；")]), _vm._v(" "), _c('p', [_vm._v("6. 因刻字服务需要，工作人员将打开香水瓶身的塑封包装进行刻字。外包装打开痕迹不可避免，敬请谅解。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1577b696"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/index.vue
// module id = 1068
// module chunks = 2